module.exports = __webpack_public_path__ + "img/gali-folha.a5ae5c43.png";